import React from 'react';
import PropTypes from 'prop-types';
import { VCARD_ACTIONS_MAIN_CLASSNAME } from '../Constants';
import VCardButton from './VCardButton';
import { cls } from '../../../packages/components';

class VCardActions extends React.PureComponent{

    handleFocus = ()=> {
        const el = this.refs['VcardActions'];
        if(el && el.parentNode && el.parentNode.parentNode){
            const grandParentEl = el.parentNode.parentNode;
            if(grandParentEl && typeof grandParentEl.scrollIntoView ==='function' ){
                grandParentEl.scrollIntoView(false);
            }
        }
    }

    render(){
        const { buttons, isLoading } = this.props;
        return (
            <div ref="VcardActions" className={VCARD_ACTIONS_MAIN_CLASSNAME} onFocus={this.handleFocus}>
                {
                    isLoading ? ( <VCardButton className={cls('bg-loading-button')}/>)
                    :
                    buttons.map((button, index) => {
                        const { id, text, family ='', style,  icon, iconClassName, className, onClick = ()=>{}, elementopredeterminado = false, type, taxes, isPromoCode }= button;
                        return <VCardButton style={style} key={icon} id={`vcardactions_${index}`} onClick={onClick} text={text} family={family} icon={icon} iconClassName={iconClassName} className={className} elementopredeterminado={elementopredeterminado} type={type} taxes={taxes} isPromoCode={isPromoCode}/>
                    })
                }
            </div>
        );
    }
}

VCardActions.propTypes = {
    buttons: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
}

VCardActions.defaultProps = {
    buttons: [],
    isLoading: false,
}

export default VCardActions;



// WEBPACK FOOTER //
// ./src/components/Ficha/components/VCardActions.jsx